import io from 'socket.io-client';

const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://connect-server-nfxv.onrender.com';

export const socket = io(serverUrl, {
  autoConnect: false, // We will connect manually after login
});
